import { render, staticRenderFns } from "./FormUppy.vue?vue&type=template&id=2ca7d003"
import script from "./FormUppy.vue?vue&type=script&lang=js"
export * from "./FormUppy.vue?vue&type=script&lang=js"
import style0 from "@uppy/core/dist/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@uppy/dashboard/dist/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports